import type { FC } from 'react';
import { BaseItem } from './BaseItem';
import type { ProductItemEditor } from '../../../../bff-api/baskets/model';
import type { Product } from '../../../../bff-api/products/model';
import type { BaseItemProps } from './BaseItem';

export type ExtendItemProps = {
    productItem: ProductItemEditor;
    product?: Product;
    extendAssociation: string;
} & Omit<BaseItemProps, 'id'>;

export const ExtendItem: FC<ExtendItemProps> = ({ extendAssociation, ...props }) => {
    const { productItem } = props;
    return (
        <BaseItem
            {...props}
            id={`cart-item-extend-${productItem.productId}-${extendAssociation}`}
            disableLink
        />
    );
};

ExtendItem.defaultProps = {
    product: undefined,
};
